import { memo, useMemo } from 'react';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import { Typography } from '@mui/material';

import { useMount } from '@cutwise/utils';

import { HttpStatus } from '@/dmdrive/core/constants/network';
import { AppError, DEFAULT_ERROR_MESSAGE } from '@/dmdrive/core/entities/AppError';

import { AppErrorMessageRoot } from './AppErrorMessage.styles';

interface AppErrorMessageProps {
  error: AppError;
}

function AppErrorMessage(props: AppErrorMessageProps) {
  const { error } = props;

  useMount(() => console.error(error));

  const ErrorIcon = useMemo(() => {
    switch (error.code) {
      case HttpStatus.Unauthorized:
        return NoAccountsIcon;
      default:
        return ReportGmailerrorredIcon;
    }
  }, [error.code]);

  return (
    <AppErrorMessageRoot>
      <ErrorIcon fontSize="large" color="error" />

      <Typography variant="h6">{error.message || DEFAULT_ERROR_MESSAGE}</Typography>

      <Typography variant="subtitle2">{error.description}</Typography>
    </AppErrorMessageRoot>
  );
}

export default memo(AppErrorMessage);
